import { modelState } from '@/utils/modelState';
import { NumericConditionComponent } from './NumericConditionComponent';
import { QueryBuilder } from './QueryBuilder';
import { v4 as uuidv4 } from 'uuid';

export namespace BookingDurationCondition {

    export const registryEntry: QueryBuilder.ConditionRegistryEntry = {
        key: "BookingDuration",
        name: "Booking Duration",
        isCondition: isBookingDurationCondition,
        create: createBookingDurationCondition,
        hydrate: hydrateBookingDurationCondition,
        serialize: serializeBookingDurationCondition,
        deserialize: deserializeBookingDurationCondition,
        renderComponent: renderComponent
    };

    export const BookingDurationCondition = Symbol("BookingDurationCondition");
    export interface BookingDurationCondition extends QueryBuilder.ConditionNodeChild {
        [BookingDurationCondition]: boolean;
        operator: modelState<string>;
        value: modelState<number>;
    }

    export function isBookingDurationCondition(condition?: QueryBuilder.ConditionNodeChild): condition is BookingDurationCondition {
        if (!condition) {
            return false;
        }

        return (condition as BookingDurationCondition)[BookingDurationCondition] === true;
    }

    export function createBookingDurationCondition(skipHydration: boolean = false): BookingDurationCondition {

        const condition: BookingDurationCondition = {
            [QueryBuilder.Node]: true,
            [QueryBuilder.ConditionNodeChild]: true,
            [BookingDurationCondition]: true,
            id: uuidv4(),
            version: modelState(0),
            operator: modelState("gt"),
            value: modelState(0),
            dispose: () => { }
        };

        if (!skipHydration) {
            hydrateBookingDurationCondition(condition);
        }

        return condition;
    }

    export function hydrateBookingDurationCondition(condition: BookingDurationCondition, recursive: boolean = false) {
        const unsubscribeList = [
            condition.operator.subscribe(() => {
                condition.version.setValue(condition.version.value + 1);
            }),
            condition.value.subscribe(() => {
                condition.version.setValue(condition.version.value + 1);
            })
        ];

        const oldDispose = condition.dispose;

        condition.dispose = () => {
            unsubscribeList.forEach(u => u());

            oldDispose();
        };
    }

    function serializeBookingDurationCondition(condition: BookingDurationCondition): QueryBuilder.ConditionChildNodeDtoWrapper {
        const conditionDto: BookingDurationConditionDto = {
            NodeId: condition.id,
            Operator: condition.operator.value,
            Value: condition.value.value
        };

        return {
            Type: "BookingDuration",
            Value: conditionDto
        };
    }

    interface BookingDurationConditionDto extends QueryBuilder.NodeDto {
        Operator: string;
        Value: number;
    }

    function deserializeBookingDurationCondition(conditionDto: BookingDurationConditionDto): BookingDurationCondition {
        const condition = createBookingDurationCondition(true);

        condition.operator.setValue(conditionDto.Operator);
        condition.operator.commit();

        condition.value.setValue(conditionDto.Value);
        condition.value.commit();

        return condition;
    }

    function renderComponent(condition: BookingDurationCondition) {
        return (
            <div>
                <NumericConditionComponent operator={condition.operator} value={condition.value} />
            </div>
        );
    }
}